const SENSITIVE_FIELDS = [
  "password", "token", "authorization", "apikey", "apiKey", "apiKeyValue",
  "user_key", "secret", "creditCard", "creditCardNumber", "cvv", "cvc", "pin",
  "numeroTarjeta", "cvvTarjeta", "numeroSeguridadTarjeta", "numeroDocumento",
  "documentId", "documento", "cedula", "cedulaRnc", "parseMasterKey",
  "parseRestApiKey", "parseApplicationId", "urlBase", "auth1", "auth2",
  "expirationDate", "mesExpiracion", "anoExpiracion", "anioExpiracion", "idEnlace", "idBoveda",
  "idPaymentProfile", "idCliente", "where", "numeroSeguridad",
];

export function sanitizeData(data) {
  if (!data) return data;
  if (typeof data === "string") {
    return data.length > 5120 ? data.substring(0, 5120) + "..." : data;
  }
  if (typeof data !== "object") return data;
  const sanitized = Array.isArray(data) ? [] : {};
  for (const key in data) {
    if (
      Object.hasOwn(data, key) &&
      SENSITIVE_FIELDS.some((field) =>
        key.toLowerCase().includes(field.toLowerCase())
      )
    ) {
      sanitized[key] = "***REDACTED***";
    } else if (data[key] !== null && typeof data[key] === "object") {
      sanitized[key] = sanitizeData(data[key]);
    } else {
      sanitized[key] = data[key];
    }
  }
  return sanitized;
}

const SENSITIVE_QUERY_PARAMS = [
  "token", "key", "apiKey", "authorization", "where", "urlbase", "id",
  "numeroReferencia", "cedulaRnc", "numeroPoliza", "numeroDocumento",
  "factura", "usuario",
];

export function sanitizeUrl(url) {
  if (!url || typeof url !== "string") return url;
  try {
    let result = url;
    const qIndex = result.indexOf("?");
    if (qIndex !== -1) {
      const base = result.substring(0, qIndex);
      const query = result.substring(qIndex + 1);
      const params = new URLSearchParams(query);
      let hasSensitive = false;
      for (const key of params.keys()) {
        const keyLower = key.toLowerCase();
        if (
          SENSITIVE_QUERY_PARAMS.some((p) => keyLower.includes(p.toLowerCase()))
        ) {
          params.set(key, "[REDACTED]");
          hasSensitive = true;
        }
      }
      result = hasSensitive ? `${base}?${params.toString()}` : result;
    }
    result = result.replaceAll(
      /\/[A-Za-z0-9_-]{20,}(?=\/|$|\?)/g,
      "/[REDACTED]"
    );
    return result;
  } catch {
    return "[REDACTED]";
  }
}

export { SENSITIVE_FIELDS, SENSITIVE_QUERY_PARAMS };
